import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-unauthorised',
  templateUrl: './unauthorised.component.html',
  styleUrls: ['./unauthorised.component.css']
})
export class UnauthorisedComponent implements OnInit {

  constructor(private auth: AuthenticationService) {     
  }

  ngOnInit(): void {
  }

 


  isLoggedIn() {
    return this.auth.isLoggedIn();
  }
  
  logout() {
    
    this.auth.logout();
  }
}
